<script>
  export default {
    name: 'btn-status-confirmar',
    props: ['Status'],
    data () {
      return {
        buttonClosed: false,
        opened: false,
        newStatus: null,
        oldStatus: null
      }
    },
    computed: {
      getStatus () {
        return this.Status
      }
    },
    mounted () {
    },
    watch: {},
    destroyed () {
    },
    methods: {
      closeButtonConfig () {
        this.buttonClosed = true
      },
      open (newStatus, oldStatus, cb) {
        this.opened = true
        this.newStatus = newStatus
        this.oldStatus = oldStatus
        this.cb = cb
        this.$nextTick(() => {
          this.$refs.btn.focus()
        })
      },
      close () {
        this.opened = false
      },
      confirm () {
        this.cb(this.newStatus)
        this.close()
      }
    },
    components: {}
  }
</script>

<template>
  <div>
    <div class="u-bg-overlay" v-if="opened"></div>
    <div class="u-theme-config-container" :class="{'is-closed': opened}">

      <div class="u-theme-config-panel" :class="{'open': opened}">

        <div v-if="opened" class="u-theme-content">

          Tem certeza que deseja alterar o status?<br><br>

          De <span class="label text-sm"
                   :class="'bg-' + getStatus[oldStatus].class">{{getStatus[oldStatus].titulo}}</span>
          para <span class="label text-sm"
                     :class="'bg-' + getStatus[newStatus].class">{{getStatus[newStatus].titulo}}</span>
          <p class="m-t-xl">
            <button ref="btn" tabindex="1" @click="confirm()" class="btn btn-success">Confirmar</button>
            <button tabindex="1" @click="close()" class="btn btn-default">Cancelar</button>
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .u-bg-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 9999996;
  }

  .u-theme-config-container {
    position: fixed;
    z-index: 9999997;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 30px;
    display: flex;
    align-content: center;
    align-items: center;
    &.is-closed {
      animation-name: fecharBonitin;
      animation-duration: .2s;
      -webkit-animation-fill-mode: forwards;
    }
  }

  .u-theme-config i:before {
    font-size: 50px;
  }

  .u-theme-config-panel {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    position: fixed;
    z-index: 9999998;
    right: -300px;
    width: 400px;
    max-height: calc(100vh - 200px);
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 14px 0 rgba(97, 123, 160, 0.4);
    opacity: 0;
    transition: all 0.3s;
    margin: auto;
    &.open {
      right: 25px !important;
      opacity: 1;
      transition: all 0.3s;
    }
  }

  .u-theme-content {
    padding: 22px;
  }

</style>



// WEBPACK FOOTER //
// ConfirmStatus.vue?354fb1bf